<div mat-dialog-title>
  Taak afsluiten zonder op te slaan
</div>
<div mat-dialog-content>
  <p>
    Let op: indien je de taak afsluit zonder op te slaan zal de data verloren gaan. Bevestig of je de taak wilt
    afsluiten.
  </p>
</div>
<mat-dialog-actions>
  <button [mat-dialog-close]="false" color="accent" mat-flat-button>Terug naar de taak</button>
  <button (click)="submit()" color="primary" mat-flat-button>Afsluiten zonder opslaan</button>
</mat-dialog-actions>
